import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { SearchStation } from "@/types";
import { AppError } from "@/types/app.type";
import { ElForm, ElInput } from "element-plus";
import { reactive, ref } from "vue";

// - refs

export default /*#__PURE__*/_defineComponent({
  props: {
    values: null
  },
  emits: ["search"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: "search", searh: SearchStation): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  values: SearchStation | undefined;
}

const form = ref<InstanceType<typeof ElForm> | null>(null);
const fieldQuery = ref<InstanceType<typeof ElInput> | null>(null);

// - properties


// - events


// - modelo formulario
const formModel = reactive<SearchStation>(
  props.values || { queryField: "ALL", query: "", group: "ALL", activeStatus: "ACTIVATED" }
);

// - validadores formulario
const rules = {};

// - methods
/**
 * method - onsubmit
 */
const onSubmit = async () => {
  if (!form.value) return;

  // - validate
  const valid = await form.value.validate();

  if (!valid) throw new Error(AppError.FORM_VALIDATION);

  // - emit search event
  emit("search", formModel);
};
const focus = () => {
  if (!fieldQuery.value) return;
  fieldQuery.value.focus();
};

expose({
  focus,
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_unref(ElForm), {
    model: _unref(formModel),
    rules: rules,
    ref_key: "form",
    ref: form,
    onSubmit: _withModifiers(onSubmit, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, { gutter: 4 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 10 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _unref(formModel).queryField,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formModel).queryField) = $event)),
                teleported: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    value: "ALL",
                    label: _ctx.$t('enum.fields.ALL')
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    value: "STATION_NAME",
                    label: _ctx.$t('enum.fields.STATION_NAME')
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    value: "STATION_STATION",
                    label: _ctx.$t('enum.fields.STATION_STATION')
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    value: "SAMPLINGPOINT_NAME",
                    label: _ctx.$t('enum.fields.SAMPLINGPOINT_NAME')
                  }, null, 8, ["label"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 14 }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElInput), {
                modelValue: _unref(formModel).query,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formModel).query) = $event)),
                placeholder: _ctx.$t('placeholder.search'),
                ref_key: "fieldQuery",
                ref: fieldQuery
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        prop: "group",
        class: "mb-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio_group, {
            modelValue: _unref(formModel).group,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formModel).group) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio, {
                label: "ALL",
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("label.all")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio, {
                label: "NO_OFFICE",
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("label.field")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio, {
                label: "OFFICE",
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("label.office")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        prop: "activeStatus",
        class: "mb-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio_group, {
            modelValue: _unref(formModel).activeStatus,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formModel).activeStatus) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio, { label: 'ALL' }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("label.all")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio, { label: 'ACTIVATED' }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("label.activated")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio, { label: 'DEACTIVATED' }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("label.deactivated")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "btn",
        type: "primary",
        "native-type": "submit"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("placeholder.search")), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "onSubmit"]))
}
}

})